<template>
  <div>
    <BCol
      md="12"
      class="d-flex justify-content-center pt-3"
    >
      <b-img
        width="100"
        src="@core/assets/image/icon-popup-success.png"
      />
    </BCol>

    <BCol class="text-center mt-2">
      <h4 class="text-black">
        <strong v-if="createpin"> {{ createpin }}</strong>
        <strong v-else-if="changepin"> {{ changepin }}</strong>
      </h4>
      <p
        v-if="createpin"
        class="text-black"
      >
        Selamat Kamu berhasil mengamankan saldo yang
        Kamu miliki.
      </p>
    </BCol>
    <div class="text-center my-2">
      <BButton
        variant="primary"
        @click="$bvModal.hide('modal-success-create-pin')"
      >
        Oke
      </BButton>
    </div>
  </div>
</template>

<script>
import { BCol, BButton } from 'bootstrap-vue'

export default {
  name: 'ModalSuccessCreatePin',
  components: {
    BCol,
    BButton,
  },
  props: {
    createpin: {
      type: String,
      default: '',
    },
    changepin: {
      type: String,
      default: '',
    },
  },
}
</script>
